/** Ikonice lijeve navigacije. Crtež linijom, 16px, nikad ispunjen i nikad u obojenom
 *  krugu; boju nasljeđuju od stavke, pa prate njeno stanje (DESIGN.md, Icons).
 *
 *  Ikonica postoji samo ovdje, na čipovima tipa dokumenta i u poplavi na telefonu.
 *  U redovima tabele je nema: 3.000 redova ikonica je 3.000 komada šuma.
 */

const putanje: Record<string, string> = {
  // linija pulsa — dan u pogonu
  danas: 'M3 12h4l3 8 4-16 3 8h4',
  // sanduk koji se otvara
  prijem: 'M21 8v13H3V8M1 3h22v5H1zM10 12h4',
  // kamion sa prikolicom
  otpremnice:
    'M1 3h15v13H1zM16 8h4l3 3v5h-7M5.5 19a2 2 0 100-4 2 2 0 000 4zM18.5 19a2 2 0 100-4 2 2 0 000 4z',
  // kutija u tri dimenzije — artikal
  katalog: 'M20 7l-8-4-8 4 8 4 8-4zM4 7v10l8 4 8-4V7M12 11v10',
  // složene police
  lager: 'M3 5h18M3 12h18M3 19h12',
  // lista sa kvačicom
  popis: 'M9 3h6v4H9zM5 7h14v14H5zM9 13l2 2 4-4',
  // zgrada
  partneri: 'M3 21V9l9-6 9 6v12M9 21v-7h6v7',
  // osoba
  korisnici: 'M16 20v-2a4 4 0 00-8 0v2M12 11a4 4 0 100-8 4 4 0 000 8z',
}

export function IkonaNav({ kljuc }: { kljuc: string }) {
  const d = putanje[kljuc]
  if (!d) return null
  return (
    <svg className="navigacija__ikona" viewBox="0 0 24 24" aria-hidden="true">
      <path d={d} />
    </svg>
  )
}
